import { createSlice } from '@reduxjs/toolkit';

const initialState = {
	total: 0,
	page: 1,
	maxPage: 1,
	products: [],
};

const productsSlice = createSlice({
	name: 'products',
	initialState: initialState,
	reducers: {
		setProducts: (state, action) => action.payload,
		reset: (state, action) => initialState,
	},
});

export const { setProducts, reset } = productsSlice.actions;

export default productsSlice.reducer;